export default __webpack_public_path__ + "static/media/WF3.1ce994fc.png";